import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {
  IPracticeModel, IResultItemPracticeModel,
  IResultPracticeModel, PracticeIndicatorModel, ResultItemPracticeModel
} from "../../../models/accounts/practice.model";



const API_PRACTICE_URL = `${environment.apiUrl}/accounts/practice/`;
const API_PRACTICE_INVITATION_URL = `${environment.apiUrl}/accounts/practice_invitation/`;

@Injectable({
  providedIn: 'root'
})
export class PracticeHttpService {

  constructor(private http: HttpClient) {
  }



  getPractices(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0): Observable<IResultPracticeModel> {
    let pars = new HttpParams();
    Object.keys(wheres).forEach((key) => {
      pars = pars.append(key, wheres[key]);
    });
    pars = pars.append('offset', offset);
    pars = pars.append('limit', limit);
    return this.http.get<IResultPracticeModel>(`${environment.apiUrl}/accounts/practice/`,{params: pars});
  }
  userRolePractice  (practiceId: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/accounts/check_role/?practice_id=${practiceId}`);
  }

  getPracticeIndicator(practiceId: string): Observable<PracticeIndicatorModel> {
    return this.http.get<PracticeIndicatorModel>(`${environment.apiUrl}/accounts/practice/${practiceId}/check`);
  }

}
